// src/utils/utils.js
import axios from "axios";

// Utility function to fetch profile image and return the URL
export const fetchFile = async (filename) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_NODE_URL}/api/agency/get-agency-profile/${filename}`,
      { responseType: "blob" }
    );

    if (response.status === 200) {
      const imageUrl = URL.createObjectURL(response.data); // Convert Blob to URL
      return imageUrl; // Return the generated URL
    } else {
      console.warn("Profile image not found");
      return null; // Return null if not found
    }
  } catch (err) {
    console.error("Error fetching profile image:", err);
    return null; // Return null on error
  }
};
